import { render } from "./AvatarComponent.vue?vue&type=template&id=26320c9d&ts=true"
import script from "./AvatarComponent.vue?vue&type=script&lang=ts"
export * from "./AvatarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__